<template>
  <span class="market-uview-icon" :style="iconStyle">{{ glyph }}</span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { getUviewIconGlyph } from '../uview-icons'

defineOptions({ name: 'MarketUviewIcon' })

const props = withDefaults(
  defineProps<{
    name: string
    size?: number | string
    color?: string
  }>(),
  {
    size: 16
  }
)

const glyph = computed(() => getUviewIconGlyph(props.name))

const iconStyle = computed(() => ({
  fontSize: typeof props.size === 'number' ? `${props.size}px` : props.size,
  color: props.color,
  lineHeight: '1'
}))
</script>

<style lang="scss">
@font-face {
  font-family: 'uicon-iconfont';
  src: url('/static/fonts/uicon-iconfont.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.market-uview-icon {
  font-family: uicon-iconfont, sans-serif;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
}
</style>
